import React from 'react';
import '../styles/Table.css';

const Table = ({ headers, rows, className = '', title = '' }) => {
  return (
    <div className={`docs-table-container ${className}`}>
      {title && <div className="docs-table-title">{title}</div>}
      <div className="docs-table-wrapper">
        <table className="docs-table">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index} className="docs-table-header">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="docs-table-row">
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className="docs-table-cell">
                    {/* Procesar contenido de celdas que puede incluir código */}
                    <div dangerouslySetInnerHTML={{ 
                      __html: cell.includes('`') 
                        ? cell.replace(/`([^`]+)`/g, '<code class="docs-inline-code">$1</code>')
                        : cell
                    }} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table; 